import {Client, Account, Databases} from 'appwrite';

export const client = new Client();

client
    .setEndpoint('https://appwrite.jellehoofs.nl/v1')
    .setProject('671fa9a2000202b92540');

export const account = new Account(client);
export { ID } from 'appwrite';

export const databases = new Databases(client);
export const databaseId = '671fa9ef003b54e9f383';
export const roomsCollectionId = '671fa9f8002ddf8eb9c1';
export const settingsCollectionId = '671faa030023f80d92e1';
